import { setSessionStore, removeSessionStore } from '@/utils/storage'
import { MENUS, MENU_BUTTONS } from '@/store/mutation-types'
// 原有流程相关状态
const flow = {
    namespaced: true,
    state: {
        processInstanceId: '',
        tableId: '',
        isTried: false,
        promoterDrawer: false,
        flowPermission1: {},
        approverDrawer: false,
        approverConfig1: {},
        copyerDrawer: false,
        copyerConfig1: {},
        conditionDrawer: false,
        conditionsConfig1: {
            conditionNodes: [],
        },
    },
    mutations: {
        setTableId(state, payload) {
            state.tableId = payload
        },
        setIsTried(state, payload) {
            state.isTried = payload
        },
        setPromoter(state, payload) {
            state.promoterDrawer = payload
        },
        setProcessInstanceId(state, payload) {
            state.processInstanceId = payload.instanceId
        },
        setFlowPermission(state, payload) {
            state.flowPermission1 = payload
        },
        setApprover(state, payload) {
            state.approverDrawer = payload
        },
        setApproverConfig(state, payload) {
            state.approverConfig1 = payload
        },
        setCopyer(state, payload) {
            state.copyerDrawer = payload
        },
        setCopyerConfig(state, payload) {
            state.copyerConfig1 = payload
        },
        setCondition(state, payload) {
            state.conditionDrawer = payload
        },
        setConditionsConfig(state, payload) {
            state.conditionsConfig1 = payload
        },
    }
}
export default flow
